// extracted by mini-css-extract-plugin
export var banner = "_ia-0";
export var closeButton = "_ia-2";
export var greenCheckmark = "_ia-3";
export var hereLink = "_ia-4";
export var titleIcon = "_ia-1";